import React from "react";
import { Monitor, Tablet, Smartphone } from "lucide-react";
import { FONT, T, DEVICES, focusRing } from "./tokens";

// ===========================================================================
// DeviceToggle — segmented Desktop / Tablet / Phone control.
// Keyboard map (Part 4.5): 1 / 2 / 3 select the matching device; the number
// is surfaced as a title + aria hint. Selection is fully keyboard-reachable.
// ===========================================================================

const ICONS = { desktop: Monitor, tablet: Tablet, mobile: Smartphone };

export default function DeviceToggle({ value, onChange }) {
  return (
    <div
      role="radiogroup"
      aria-label="Preview device"
      style={{
        display: "inline-flex",
        gap: 2,
        padding: 3,
        borderRadius: T.radiusFull,
        background: "rgba(255,255,255,0.55)",
        border: `1px solid ${T.line}`,
        boxShadow: T.shadowSm,
      }}
    >
      {DEVICES.map((d) => {
        const Icon = ICONS[d.id];
        const active = value === d.id;
        return (
          <button
            key={d.id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={`${d.label} (press ${d.key})`}
            title={`${d.label} · ${d.key}`}
            onClick={() => onChange(d.id)}
            onFocus={(e) => (e.currentTarget.style.boxShadow = focusRing.boxShadow)}
            onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              height: 30,
              padding: "0 12px",
              border: "none",
              cursor: "pointer",
              borderRadius: T.radiusFull,
              fontFamily: FONT,
              fontSize: 12.5,
              fontWeight: 600,
              color: active ? "#fff" : T.ink2,
              background: active ? T.blue : "transparent",
              transition: `background var(--ds-dur-fast) ${T.easeOut}, color var(--ds-dur-fast) ${T.easeOut}`,
            }}
          >
            <Icon size={14} strokeWidth={1.8} aria-hidden="true" />
            <span>{d.label}</span>
          </button>
        );
      })}
    </div>
  );
}
